<div class="row animated fadeInDown" *ngIf="this.usuarioConsultadoId > 0 && !this.usuarioAtivo">
  <div class='desativado'>
    Usuário desativado
  </div>
</div>

<div class="row">

  <div class="col-md-3">

    <div class="box"
      [ngClass]="{'box-primary': modoInsercao, 'box-warning': !modoInsercao && usuarioAtivo, 'box-danger' : !modoInsercao && !usuarioAtivo}">



      <div class="box-header text-center">
        <h3 class="box-title ">Usuários Cadastrados</h3><br />
        <span class="text-muted">Selecione para editar</span>
      </div>

      <div class="box-body">


        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="nome/login (contém)" #inputSearchNomeLogin maxlength="20" />
              <div class="input-group-append cp">
                <button type="button" class="btn btn-light pl-4 pr-4" (click)="getUsuarioPorNomeLogin(inputSearchNomeLogin.value)">
                  <i class="fa fa-search">
                 

                  </i>
                </button>
                <button type="button" class="btn btn-light" (click)="resetSearch()">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
        
        <div class="divider"></div>

        <div class="box-table" style="height: 310px">

          <table>
            <thead>
            <tr class="text-center" *ngIf="this.searchLoading">
              <td colspan="2" class="td-border-hidden">
                <span *ngIf="this.searchLoading" class="fa fa-spinner fa-spin fa-fw"></span>
              </td>
              </tr>
              <tr>
                <th>Foto</th>
                <th>Login</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let u of cadastrados" class="cp" (click)="getUsuario(u.id, u.ativo)"
                [ngClass]="{'tr-info': this.form.controls['id'].value == u.id}">
                <td>
                  <img *ngIf="u.foto != null && u.foto != ''" class="rounded-circle foto-lista"
                    [src]="getSantizeUrl(u.fotoMimeType, u.foto)" />
                  <img *ngIf="u.foto == null || u.foto == ''" class="rounded-circle foto-lista"
                    src="./assets/images/no-image.png" />
                </td>
                <td [ngClass]="{'text-danger': !u.ativo}" class="text-center">{{ u.login }}
                  <span *ngIf="this.usuarioLogadoId === u.id" class="text-success"> (eu)</span>
                </td>
              </tr>
            </tbody>

          </table>


        </div>


      </div>

      <div class="box-footer">
        <span class="pl-1">Total: <b>{{ this.cadastrados.length }}</b> </span>
      </div>
    </div>
  </div>



  <div class="col-md-9">

    <div class="box"
      [ngClass]="{'box-primary': modoInsercao, 'box-warning': !modoInsercao && usuarioAtivo, 'box-danger' : !modoInsercao && !usuarioAtivo}">

      <div class="box-body" style="height: 520px;">
        <div class="row">
          <div class="col-md-9 pl-5" style="margin-bottom: 50px;">

            <form novalidate [formGroup]="form" id="form" (validSubmit)="submit()">

              <!-- *************** inputs hiddens  *************-->
              <input class="form-control text-center" formControlName="id" type="text" hidden>
              <input class="form-control text-center" formControlName="foto" type="text" hidden>
              <input class="form-control text-center" formControlName="fotoMimeType" type="text" hidden>
              <input class="form-control text-center" formControlName="nivel" type="text" hidden>

              <div class="position-relative row form-group">
                <label class="col-sm-2 col-form-label" for="Nome">Nome</label>
                <div class="col-sm-10">
                  <input class="form-control" type="text" formControlName="nome" maxlength="40" required>
                </div>
              </div>

              <div class="position-relative row form-group">
                <label class="col-sm-2 col-form-label" for="Login">Login</label>
                <div class="col-sm-10">
                  <input class="form-control" type="text" formControlName="login" maxlength="20" required>
                </div>
              </div>

              <div class="position-relative row form-group">
                <label class="col-sm-2 col-form-label" for="email">E-mail</label>
                <div class="col-sm-10">
                  <input class="form-control" type="email" formControlName="email" maxlength="40">
                </div>
              </div>

              <div class="position-relative row form-group">
                <label class="col-sm-2 col-form-label" for="Telefone">Telefone</label>
                <div class="col-sm-10">
                  <input class="form-control" type="text" formControlName="telefone" maxlength="40">
                </div>
              </div>

              <div class="position-relative row form-group animated fadeInDown"
                *ngIf="this.form.get('tipoAcesso').value == 1 || this.form.get('tipoAcesso').value == 2 ">
                <label class="col-sm-2 col-form-label" for="codigoDispositivo">Dispositivo</label>
                <div class="col-sm-10">
                  <input class="form-control" type="number" formControlName="codigoDispositivo"
                    placeholder="Código do Dispositivo Móvel">
                </div>
              </div>

            </form>
          </div>

          <div class="col-md-3">
            <div class="d-flex justify-content-end">
              <div class=col-md-12>
                <div class="box-foto">
                  <img *ngIf="this.fotoBase64 == null" class="img-fluid" src="./assets/images/no-image.png" />
                  <img *ngIf="this.fotoBase64 != null" class="img-fluid" [src]="this.fotoBase64" />
                </div>
                <button type="button" class="btn btn-light" (click)="fileInput.click()">Selecione uma Foto</button>
                <input type='file' style="display:none" (change)="upload(fileInput.files)" #fileInput
                  accept="image/png, image/jpeg" />
              </div>

            </div>
          </div>
        </div>

        <div class="divider"></div>

        <section class="mt-5">
        <!-- BOTÕES NÍVEL DE ACESSO -->
        <div class="row">
          <div class="col-md-6">
            <p class="text-center">Tipo de Acesso concedido ao Usuário</p>
          </div>
          <div class="col-md-6">
            <p class="text-center">Nível de Acesso concedido ao Usuário</p>
          </div>
        </div>
        <div class="row" style="padding-left: 15px; padding-right: 15px;">
          <div class="col-md-6">
            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="getTipoAcessoUsuario(1)"
                  [ngClass]="{'btn-info': this.form.controls['tipoAcesso'].value == 1, 'btn-light' :  this.form.controls['tipoAcesso'].value!= 1 }">Ambos</button>
              </div>
            </div>

            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="getTipoAcessoUsuario(2)"
                  [ngClass]="{'btn-info': this.form.controls['tipoAcesso'].value == 2, 'btn-light' :  this.form.controls['tipoAcesso'].value!= 2 }">Mobilidade</button>
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn" (click)="getTipoAcessoUsuario(3)"
                  [ngClass]="{'btn-info': this.form.controls['tipoAcesso'].value == 3, 'btn-light' :  this.form.controls['tipoAcesso'].value != 3 }">Web</button>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn  btnNivel podeIncluirNivel"
                  (click)="getFuncionalidadesNivelUsuarios(1)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 1, 'btn-light' :  this.form.controls['nivel'].value!= 1 }"
                  [disabled]="this.nivelUsuarioLogado <= 2 || (this.nivelUsuarioLogado < 5 && this.usuarioLogadoId === this.usuarioConsultadoId)">Solicitante</button>
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn  btnNivel podeIncluirNivel"
                  (click)="getFuncionalidadesNivelUsuarios(2)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 2, 'btn-light' :  this.form.controls['nivel'].value != 2 }"
                  [disabled]="this.nivelUsuarioLogado <= 2 || (this.nivelUsuarioLogado < 5 && this.usuarioLogadoId === this.usuarioConsultadoId)">Gestor</button>
              </div>
            </div>

            <div class="btn-group btn-group-justified">
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-light btnNivel podeIncluirNivel"
                  (click)="getFuncionalidadesNivelUsuarios(3)"
                  [ngClass]="{'btn-info': this.form.controls['nivel'].value == 3, 'btn-light' :  this.form.controls['nivel'].value != 3 }"
                  [disabled]="this.nivelUsuarioLogado <= 3 || (this.nivelUsuarioLogado < 5 &&this.usuarioLogadoId === this.usuarioConsultadoId)">Administrativo</button>
              </div>

            </div>
          </div>



        </div>
      </section>


      </div>
    </div>
  </div>
</div>

<!-- ************************* GRID AUTORIZAÇÕES **************************-->
<section style="min-height: 400px;">
  <div class="row">
    <div class="col">
      <div class="box"
        [ngClass]="{'box-primary': modoInsercao, 'box-warning': !modoInsercao && usuarioAtivo, 'box-danger' : !modoInsercao && !usuarioAtivo}">
        <div class="box-header with-border text-center">
          <h3 class="box-title ">Autorizações no Nível do Usuário</h3><br />
          <span class="text-muted">Para cada funcionalidade do sistema, marque as autorizações concedidas ao
            usuário</span>
        </div>
        <div class="box-body">
          <table class="table table-bordered table-striped table-hover">

            <thead>
              <tr class="bg-light">
                <th>Grupo</th>
                <th>Funcionalidade</th>
                <th *ngFor="let cbxTodos of tipoAutorizacoes; let index=index"
                  title="Marcar/Desmarcar esta autorização em todas as funcionalidades">
                  <!-- <input type="checkbox" #mdt (change)="setMarcarDesmarcarTodos(index, mdt.checked)" 
                    [disabled]="this.usuarioLogadoId === this.usuarioConsultadoId" /> -->
                  <input type="checkbox" #mdt (change)="setMarcarDesmarcarTodos(index, mdt.checked)" id="mdt" />
                </th>
              </tr>
            </thead>

            <!-- Exibe as funcinalidades agrupadas por nível de acesso-->
            <tbody *ngFor="let n of this.niveisDeAcesso; let indiceNivel = index">

              <!-- Cabeçalho do nível-->
              <tr [ngStyle]="{ 'background-color' : paletaDeCoresFundo[indiceNivel]}">
                <td colspan="2" class="text-center" [ngStyle]="{ 'color': paletaDeCoresFonte[indiceNivel]}">
                  Nível de acesso
                  <b>{{ n }}</b>
                </td>
                <td *ngFor="let ta of this.tipoAutorizacoes" class="text-center"
                  [ngStyle]="{ 'color': paletaDeCoresFonte[indiceNivel]}">{{ ta }}
                </td>
              </tr>

              <!-- Lista de funcionalidade do nível -->
              <tr *ngFor="let f of this.arrayFuncionalidades[indiceNivel]">
                <td>{{ f.grupo}}</td>
                <td [title]="f.descricao">{{ f.nome }}</td>


                <td class="text-center" *ngIf="f.fPodeAcessar; else fPodeAcessar">
                  <input type="checkbox" title="Pode Acessar" #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 0, aut.checked, f)"
                    [checked]="f.uPodeAcessar"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulPodeAcessar || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fPodeAcessar>
                  <td class="text-center">-</td>
                </ng-template>

                <td class="text-center" *ngIf="f.fPodeIncluir; else fPodeIncluir">
                  <input type="checkbox" title="Pode Incluir/Salvar/Executar " #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 1, aut.checked, f)"
                    [checked]="f.uPodeIncluir"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulPodeIncluir || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fPodeIncluir>
                  <td class="text-center">-</td>
                </ng-template>

                <td class="text-center" *ngIf="f.fPodeExcluir; else fPodeExcluir">
                  <input type="checkbox" title="Pode Excluir" #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 2, aut.checked, f)"
                    [checked]="f.uPodeExcluir"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulPodeExcluir || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fPodeExcluir>
                  <td class="text-center">-</td>
                </ng-template>

                <td class="text-center" *ngIf="f.fPodeAlterar; else fPodeAlterar">
                  <input type="checkbox" title="Pode Alterar/Editar" #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 3, aut.checked, f)"
                    [checked]="f.uPodeAlterar"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulPodeAlterar || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fPodeAlterar>
                  <td class="text-center">-</td>
                </ng-template>


                <td class="text-center" *ngIf="f.fPodeListar; else fPodeListar">
                  <input type="checkbox" title="Pode Listar/Pesquisar/Imprimir " #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 4, aut.checked, f)" [checked]="f.uPodeListar"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulPodeListar || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fPodeListar>
                  <td class="text-center">-</td>
                </ng-template>


                <td class="text-center" *ngIf="f.fEstaAutorizado; else fEstaAutorizado">
                  <input type="checkbox" title="{{a}}" #aut
                    (change)="marcaDesmarcaAutorizacao(f.funcionalidadeId, 5, aut.checked, f)"
                    [checked]="f.uEstaAutorizado"
                    [disabled]="(this.nivelUsuarioLogado < 5 && (!f.ulEstaAutorizado || this.usuarioLogadoId === this.usuarioConsultadoId))"
                    class="cp">
                </td>
                <ng-template #fEstaAutorizado>
                  <td class="text-center">-</td>
                </ng-template>

              </tr>

            </tbody>

          </table>
        </div>
      </div>
    </div>
  </div>

</section>


<!-- ************************** RODAPÉ  ***************************** -->

<div class="row">
  <div class="col">
    <div class="box"
      [ngClass]="{'box-primary': modoInsercao, 'box-warning': !modoInsercao && usuarioAtivo, 'box-danger' : !modoInsercao && !usuarioAtivo}">
      <div class="box-body">
        <div class="row">

          <div class="col-md-6">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-2"
                [disabled]="!this.usuarioAutorizacoes?.podeAlterar" (click)="resetarSenhaUsuario()"><i
                  class="fa fa-unlock pr-2"></i>Resetar Senha do Usuário</button>
              <button class="btn btn-light pl-3 pr-3"
                [disabled]="!this.usuarioAutorizacoes?.podeExcluir || (this.nivelUsuarioLogado < 5 && this.usuarioLogadoId === this.usuarioConsultadoId)"
                (click)="ativarDesativarUsuario()">
                <i class="fa mr-3" [ngClass]="{'fa-check' : !this.usuarioAtivo, 'fa-ban' : this.usuarioAtivo}"></i>
                {{ this.usuarioAtivo ? 'Desativar' : 'Ativar' }} <i class="mr-2">&nbsp;</i>
              </button>
            </div>
          </div>

          <div class="col-md-2">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>

          <div class="col-md-4">
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-2" (click)="reset()">Novo</button>
              <!--  <button type="submit" class="btn btn-primary pl-5 pr-5" form="form">Salvar</button>  -->
              <button class="btn btn-lg btn-shadow"
                [disabled]="(!(this.modoInsercao && this.usuarioAutorizacoes?.podeIncluir) && !(!this.modoInsercao && this.usuarioAutorizacoes?.podeAlterar))"
                [ngClass]="{ 'btn-primary' : modoInsercao, 'btn-warning' : !modoInsercao }" type="submit" form="form">
                <i class="fa mr-3" [ngClass]="{'fa-plus' : modoInsercao, 'fa-edit' : !modoInsercao}"></i>
                {{ modoInsercao ? 'Cadastrar' : 'Editar' }} <i class="mr-2">&nbsp;</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>